import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Address, Country } from '@app/shared/interfaces';
import { CountriesService } from '@app/shared/services/countries.service';
import { ReplaySubject } from 'rxjs';
import { Owner, Property } from '../../models/statements.models';
import { StatementsFacade } from '../../services/statements.facade';

@Component({
  standalone: false,
  selector: 'hospitable-statements-owner-form',
  templateUrl: './statements-owner-form.component.html',
  styleUrls: ['./statements-owner-form.component.scss'],
})
export class StatementsOwnerFormComponent implements OnChanges {
  countries: Country[] = [];

  /** list of countries filtered by search keyword */
  public filteredCountries$: ReplaySubject<Country[]> = new ReplaySubject<Country[]>(1);

  addressExpanded = false;
  propertiesBelongingToAnotherOwner: { id: number; reason: string }[] = [];

  @Input() owner: Owner = this.statementsService.newOwner();
  @Input() mode: 'add' | 'edit';
  @Input() properties: Property[] = [];
  @Output() ownerChange = new EventEmitter<Owner>();

  constructor(
    private statementsService: StatementsFacade,
    private countriesService: CountriesService
  ) {
    this.countriesService.getCountries().subscribe((countries) => {
      this.countries = countries;
      this.filteredCountries$.next(countries.slice());
    });
  }

  ngOnChanges() {
    this.propertiesBelongingToAnotherOwner = this.properties
      .filter((property) => property.owners.length > 0 && property.owners[0].id !== this.owner.id)
      .map((property) => ({
        id: property.id,
        reason: `This property is already assigned to another owner`,
      }));
  }

  protected filterCountries(searchTerm: string) {
    if (!this.countries) {
      return;
    }

    let search = searchTerm;

    if (!search) {
      this.filteredCountries$.next(this.countries.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredCountries$.next(this.countries.filter((country) => country.name.toLowerCase().indexOf(search) > -1));
  }

  setAddress(event: Address) {
    if (event.line1) {
      this.owner.address = event;
      this.ownerChange.emit(this.owner);
    }
  }
}
